module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back page-step3",
    staticStyle: {
      "padding": "0.2rem 0 8rem 0"
    }
  }, [_c('van-form', {
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("食宿安排")]), _vm._v(" "), (_vm.qunQrcodeDisplayList.length) ? _c('van-divider', [_vm._v("群二维码")]) : _vm._e(), _vm._v(" "), (_vm.qunQrcodeDisplayList.length) ? _c('div', {
    staticClass: "qrcode-block"
  }, _vm._l((_vm.qunQrcodeDisplayList), function(url, idx) {
    return _c('div', {
      key: idx,
      staticClass: "qrcode-item"
    }, [_c('img', {
      staticClass: "qrcode-img",
      attrs: {
        "src": url,
        "alt": "群二维码"
      }
    })])
  }), 0) : _vm._e(), _vm._v(" "), _c('van-cell-group', [_c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "报名人数",
      "value": String(_vm.shisu_member_count)
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "房间可入住人数",
      "value": String(_vm.orderData.countExceptCaipan)
    }
  }), _vm._v(" "), _vm._l((_vm.orderData.list.filter(function (item) { return item.show_caipan === 2; })), function(room, rindex) {
    return _c('van-cell', {
      key: 'n-' + rindex,
      attrs: {
        "label": room.price + '元/间/天 可住' + room.limit + '人',
        "input-align": "right",
        "title": room.name
      }
    }, [(room.edit_admin === 2) ? _c('span', [_c('van-stepper', {
      attrs: {
        "integer": "",
        "min": 0,
        "max": room.stock > 0 ? room.last_stock : 999999999
      },
      on: {
        "change": _vm.countChange
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1) : _c('span', [_vm._v("\n          " + _vm._s(room.count) + "间\n          "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("请联系食宿负责人修改")])])])
  }), _vm._v(" "), (_vm.row.caipan_count > 0 && _vm.orderData.list.filter(function (item) { return item.show_caipan === 1; }).length > 0) ? _c('div', [_c('van-divider', [_vm._v("裁判员食宿安排")]), _vm._v(" "), _vm._l((_vm.orderData.list.filter(function (item) { return item.show_caipan === 1; })), function(room, rindex) {
    return _c('van-cell', {
      key: 'c-' + rindex,
      attrs: {
        "input-align": "right",
        "title": room.name
      }
    }, [(room.edit_admin === 2) ? _c('span', [_c('van-stepper', {
      attrs: {
        "integer": "",
        "min": 0,
        "max": room.stock > 0 ? room.last_stock : 1
      },
      on: {
        "change": function($event) {
          return _vm.caipanCountChange(room)
        }
      },
      model: {
        value: (room.count),
        callback: function($$v) {
          _vm.$set(room, "count", $$v)
        },
        expression: "room.count"
      }
    })], 1) : _c('span', [_vm._v("\n            " + _vm._s(room.count) + "间\n            "), _c('div', {
      staticClass: "operate-desc-left"
    }, [_vm._v("请联系食宿负责人修改")])])])
  })], 2) : _vm._e(), _vm._v(" "), _c('van-divider', [_vm._v("食宿费用")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "input-align": "right",
      "title": "食宿费用",
      "value": _vm.orderData.price + '元'
    }
  })], 2), _vm._v(" "), _c('van-notice-bar', {
    attrs: {
      "wrapable": "",
      "scrollable": false,
      "text": "此项费用为房型费用估算（单价×间数×入住天数），最终以确认订单页为准。"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "button"
    },
    on: {
      "click": _vm.goPrev
    }
  }, [_vm._v("上一步\n      ")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "native-type": "submit",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    }
  }, [_vm._v("保存并继续\n      ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fad60924","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/AbilityApplyStep3.vue
// module id = 2642
// module chunks = 0